
















































































































































































































































import ModalTabMixin from '@/mixins/modal-tab.mixin';
import { compass } from '@resclick/compass';
import { CURRENCY_CODES, IPaymentOptionGroup, IProperty, TIME_ZONE_CODES } from '@resclick/data-access';
import { Component } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

@Component
export default class TabGeneral extends ModalTabMixin<'properties', 'create' | 'update'> {
  @Getter('user/currentCompany') currentCompany!: string;

  paymentOptionGroupList: Array<IPaymentOptionGroup & { id: string }> = [];

  get paymentOptionGroupOptions() {
    return this.paymentOptionGroupList.map((paymentOptionGroup: IPaymentOptionGroup & { id: string }) => {
      return {
        label: paymentOptionGroup.name,
        value: paymentOptionGroup.id,
      };
    });
  }

  get timeZoneOptions() {
    return TIME_ZONE_CODES;
  }

  get defaultCurrencyOptions() {
    return CURRENCY_CODES;
  }

  get addressValidators() {
    return {
      country: {
        hasError: this.form.hasError('address.country'),
        message: this.form.getError('address.country'),
      },
      province: {
        hasError: this.form.hasError('address.province'),
        message: this.form.getError('address.province'),
      },
      district: {
        hasError: this.form.hasError('address.district'),
        message: this.form.getError('address.district'),
      },
    };
  }

  get phoneNumberValidators() {
    return {
      countryCode: {
        hasError: this.form.hasError('phoneNumber.countryCode'),
        message: this.form.getError('phoneNumber.countryCode'),
      },
      areaCode: {
        hasError: this.form.hasError('phoneNumber.areaCode'),
        message: this.form.getError('phoneNumber.areaCode'),
      },
      number: {
        hasError: this.form.hasError('phoneNumber.number'),
        message: this.form.getError('phoneNumber.number'),
      },
    };
  }

  get lat() {
    return this.form.fields?.location?.coordinates[0] || 0;
  }

  get lng() {
    return this.form.fields?.location?.coordinates[1] || 0;
  }

  get mapCenter() {
    return {
      lat: this.lat,
      lng: this.lng,
    };
  }

  getForm() {
    return compass.do('properties', 'findOne', {
      params: { propertyId: this.id || '' },
    });
  }

  async mounted() {
    const { data } = await compass.do('paymentOptionGroups', 'find', {});
    this.paymentOptionGroupList = data as Array<IPaymentOptionGroup & { id: string }>;
  }

  created() {
    this.form = this.$crsForm('properties', this.mode, {
      category: '',
      isActive: false,
      name: '',
      company: this.currentCompany,
      type: 'HOTEL',
      location: {
        coordinates: [0, 0],
        type: 'Point',
      },
      email: '',
      phoneNumber: {
        countryCode: '',
        areaCode: '',
        number: '',
      },
      timeZone: 'Europe/Istanbul',
      contactPerson: '',
      website: '',
      totalRooms: 0,
      defaultCurrency: '',
      // defaultGateway: '',
      paymentOptionGroup: '',
      address: {
        line1: '',
        line2: '',
        postalCode: '',
      },
    });
    this.$on('update-data', (data: IProperty) => {
      this.form = this.$crsForm('properties', 'update', data);
    });
  }
}
